const RESERVED_PATH_PREFIXES = ['/checkout', '/checkouts', '/stores', '/kiosks', '/embedded-menu', '/_next'] as const;

/** Paths owned by checkout/menu/runtime routing and unavailable to authored CMS pages. */
export function isReservedCmsPath(path: string): boolean {
  const normalized = path.trim().replace(/\/+$/, '') || '/';
  return RESERVED_PATH_PREFIXES.some((prefix) => normalized === prefix || normalized.startsWith(`${prefix}/`));
}

export const RESERVED_CMS_PATH_ERROR =
  'This path is reserved for Dutchie storefront functionality. Choose a different page path.';
